import { Component, OnInit } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ReactiveDialogContentComponent } from '@app/shared/components/dialog/reactive-dialog/base/reactive-dialog-content/reactive-dialog-content.component';
import { SpacerComponent } from '../../spacer/spacer.component';
import { KundenportalConfirmationInfoDialogComponent } from '../kundenportal-confirmation-info-dialog/kundenportal-confirmation-info-dialog.component';
import { AbstractReactiveDialogComponent } from '../reactive-dialog/base/abstract-reactive-dialog-component';

@Component({
  selector:    'app-kundenportal-confirmation-dialog',
  templateUrl: './kundenportal-confirmation-dialog.component.html',
  styleUrls:   [
    './kundenportal-confirmation-dialog.component.scss'
  ] // TODO refactor
  ,
  standalone: true,
  imports:    [
    ReactiveDialogContentComponent,
    SpacerComponent,
    MatButton,
    MatIconButton,
    MatTooltip,
    MatIcon
  ]
})
export class KundenportalConfirmationDialogComponent extends AbstractReactiveDialogComponent<never, boolean> implements OnInit {

  ngOnInit(): void {
    this.dialogInputData.title = 'Kundenportal';
  }

  onConfirm(value: boolean) {
    this.dialogRef.close({
      data:   value,
      status: 'success'
    });
  }

  showInfoDialog() {
    this.dialogService.open(KundenportalConfirmationInfoDialogComponent);
  }
}
